// extracted by mini-css-extract-plugin
module.exports = {"snackbarsContainer":"Snackbar_snackbarsContainer__270jb"};